import { cn } from "@design-system/utils";
import { ChevronDown } from "lucide-react";
import * as React from "react";

import { Button } from "../button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../dropdown-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "../tooltip";

interface CheckboxMenuItem {
  id: string;
  label: string;
  checked: boolean;
}

interface CheckboxMenuProps {
  items: CheckboxMenuItem[];
  onItemCheckedChange: (id: string, checked: boolean) => void;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  tooltip?: string;
  className?: string;
  disabled?: boolean;
}

function CheckboxMenu({
  items,
  onItemCheckedChange,
  icon: Icon,
  label,
  tooltip,
  className,
  disabled,
}: CheckboxMenuProps) {
  const trigger = (
    <DropdownMenuTrigger asChild>
      <Button
        type="button"
        aria-label={label}
        disabled={disabled}
        className={cn(
          "aria-expanded:bg-shape-neutral-outlined-background-pressed",
          className
        )}
      >
        <Icon aria-hidden />
        <ChevronDown aria-hidden />
      </Button>
    </DropdownMenuTrigger>
  );

  return (
    <DropdownMenu>
      {tooltip ? (
        <Tooltip>
          <TooltipTrigger asChild>{trigger}</TooltipTrigger>
          <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
      ) : (
        trigger
      )}
      <DropdownMenuContent align="end">
        {items.map((item) => (
          <DropdownMenuCheckboxItem
            key={item.id}
            checked={item.checked}
            indicatorSide="right"
            onCheckedChange={(checked) =>
              onItemCheckedChange(item.id, Boolean(checked))
            }
            onSelect={(event) => event.preventDefault()}
          >
            {item.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { CheckboxMenu };
export type { CheckboxMenuItem, CheckboxMenuProps };
